import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Tabs, Tab } from 'react-bootstrap';
import Team from './settings/Team';
import CompanySettings from './settings/CompanySettings';
import YourDetails from './settings/YourDetails';
import WebTracking from './settings/WebTracking';
import './settings/settings.css';

const Settings: React.FC = () => {
  const [key, setKey] = useState<string>('your-details');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const segments = location.pathname.split('/');
    const currentTab = segments.pop();
    if (segments.length > 1 && currentTab) {
      setKey(currentTab);
    }
  }, [location.pathname]);

  const handleSelect = (k: string | null) => {
    if (!k) return;

    navigate(`/settings/${k}`);
    setKey(k);
  };

  return (
    <div className='page-wrapper'>
      <div className='page-inner-wrapper settings-page settings'>
        <div className='page-header-area'>
          <div className='title-and-text'>
            <h3>Settings</h3>
          </div>
        </div>
        <div className='settings-main'>
          <Tabs
            activeKey={key}
            onSelect={handleSelect}
            className='dream-left-tabs settings-tabs'
          >
            <Tab eventKey='your-details' title='Your details'>
              <YourDetails />
            </Tab>
            <Tab eventKey='team' title='Team'>
              <Team />
            </Tab>
            <Tab eventKey='web-tracking' title='Web Tracking'>
              <WebTracking />
            </Tab>
            <Tab eventKey='company-settings' title='Company Settings'>
              <CompanySettings />
            </Tab>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default Settings;
